import UserManagement from "../../../components/Setting/UserManagement";
import React, { useState, useEffect } from "react";
import { Image } from "antd";
import menu from "../../../assets/Images/menudots.svg";
import plus from "../../../assets/Images/plus.svg";
import noImage from "../../../assets/Images/roundimage.png";

import { Dropdown } from "antd";
import AddUser from "../../../components/Setting/AddUser";
import { Breadcrumb } from "antd";
import {
  DoubleRightOutlined,
  DeleteOutlined,
  EditOutlined,
  StopOutlined,
} from "@ant-design/icons";
import Sidebar from "../../../components/SideBar/sidebar";
import Navbar from "../../../components/Navbar/Navbar";
import { routes } from "../../../Routes";
import {
  blockStoreUser,
  getStoreUsers,
} from "../../../API  Functions/UserMangement";
import { useSelector } from "react-redux";
import Blockuserpopup from "../../../modals/Blockuserpopup";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import LoadingSpinner from "../../../components/Loading";
import { toast } from "react-toastify";
import {
  GetRetailerDetails,
  getSubstores,
} from "../../../API  Functions/ProfileFunctions";
import { checkPermission } from "../../../Utils/permissionHelper";
import SearchBox from "../../../components/CustomWidgets/SearchBox";
import { createSalesman, getAllSalesman, updateSalesman } from "../../../API  Functions/SalesmanApis";
import { Modal, Input } from "antd";
import { InputBox } from "../../../components/CustomWidgets/InputBox";
import FlagIcon from "../../../assets/egypt.svg";

// Dropdown data array

//

const AllSalesman = () => {
  const { t, i18n } = useTranslation();
  // const user_id = useSelector((state) => state.login?.user?.user_id);
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const store_id = useSelector((state) => state.login?.user?.result?.company_id);
  const store_data = useSelector((state) => state.login?.user?.result);
  const isGinne = useSelector((state) => state?.geneLoginReducer?.isGinneLogin);

  // This is for use in add user button to open a new component
  const [showComponent, setShowComponent] = useState(false);
  const [storeuser, setstoreuser] = useState(null);

  const [popup, setpopup] = useState(false);
  const [blockdata, setblockdata] = useState([]);
  const [status, setstatus] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);


  const [data, setData] = useState([]);
  const [salesmanData, setSalesmanData] = useState([]);
  const [allSalesmanData, setAllSalesmanData] = useState([]);
  const [retailerData, setretailerData] = useState({});
const [allUsers, setAllUsers] = useState([]); // 🔹 backup for search
const [isModalOpen, setIsModalOpen] = useState(false);
const [salesmanName, setSalesmanName] = useState("");
const [salesmanPhone, setSalesmanPhone] = useState("");
const [editSalesManID, setEditSalesManID] = useState(null);

  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store
  );
  const [subStores, setSubStores] = useState([]);
  const masterStore = useSelector((state) => state.login.masterStore);

  const [noOfUserLimit, setNoOfUserLimit] = useState(0);
  const [noOfUserCreated, setNoOfUserCreated] = useState(0);

 useEffect(() => {
    fetchdetails();
    GetSalesmanData();
  }, []);

const GetSalesmanData = async()=>{
     try {
          const res1 = await getAllSalesman(store_id);
    
          if (res1?.result?.status_code === 200) {
            const activeUsers = res1.result?.data
            console.log("Slesmans===>",activeUsers);
            
            setSalesmanData(activeUsers);
            setAllSalesmanData(activeUsers)
          } else {
            setSalesmanData([]);
          }
        } catch (error) {
          console.error("Error fetching KPI data:", error);
        }
}

  useEffect(() => {
    fetchdetails();
    GetSalesmanData();
  }, []);

  const fetchdetails = () => {
    GetRetailerDetails(user_id).then((result) => {
      if (result) {
        setretailerData(result?.retailer_details);
      }
    });
  };
  const blockstoreuser = async (val, block) => {
    const response = await blockStoreUser(
      user_id,
      val?.retailer_user_id
      // store_id,
      // val?.user_id ?? 0,
      // val?.user_record_link_id ?? 0,
      // block
    );
    // console.log("SSSSSSSSSS response", response?.data?.result[0]?.status);
    if (response?.data?.result[0]?.status === "Retailer User Deactivated") {
      setstatus(block);
      setblockdata(val);
      setpopup(true);
    } else if (
      response?.data?.result[0]?.status ===
      "Please close the POS session for this user"
    ) {
      toast.error("Please close the POS session for this user");
    }
  };


  const searchUser = (searchText) => {
  if (!searchText || searchText.trim() === "") {
    setSalesmanData(allSalesmanData); // reset when empty
    return;
  }

  const text = searchText.toLowerCase();

const filteredUsers = allSalesmanData.filter((user) => {
  const name = typeof user?.name === "string" ? user.name.toLowerCase() : "";
  const email =
    typeof user?.salesman_no === "string" ? user.salesman_no.toLowerCase() : "";
  const phone =
    typeof user?.phone_no === "string" ? user.phone_no.toLowerCase() : "";

  return (
    name.includes(text) ||
    email.includes(text) ||
    phone.includes(text)
  );
});


  setSalesmanData(filteredUsers);
};

 const getMaxLength = (mobile) => {
    return mobile?.startsWith("0") ? 11 : 10;
  };



  const handleAddSalesman = async () => {
  if (!salesmanName || !salesmanPhone) {
    toast.error(t("Please enter name and phone number"));
    return;
  }
    if (salesmanPhone?.length < 10) {
    toast.error(t("Invalid phone number"));
    return;
  }
  try {
    const payload = {
      name: salesmanName?.trim(),
      phone_no: salesmanPhone,
    company_id: store_id,
    };

    console.log("Payload", payload);

    // call your API here
   const res1 = await createSalesman(payload);


 
if(res1.result.status_code == 200){
      toast.success(t("Salesman added successfully"));
     setIsModalOpen(false);
    setSalesmanName("");
    setSalesmanPhone("");
    GetSalesmanData();
   }else{
    if(res1.result.status_code == 400 && res1.result.status?.includes('already exists')){
    toast.error(t("Salesman already exist with this number"));
    }else{
       toast.error(t(res1.result.status));
    }
   }
   

  } catch (error) {
    console.error(error);
  }
};

 const handleUpdateSalesman = async () => {
  if (!salesmanName || !salesmanPhone) {
    toast.error(t("Please enter name and phone number"));
    return;
  }
  if (salesmanPhone?.length < 10) {
    toast.error(t("Invalid phone number"));
    return;
  }

  try {
    const payload = {
      name: salesmanName?.trim(),
      phone_no: salesmanPhone,
    company_id: store_id,
    salesman_id:editSalesManID
    };

    console.log("Payload", payload);

    // call your API here
   const res1 = await updateSalesman(payload);

    if(res1.result.status_code == 200){
    toast.success(t("Salesman updated successfully"));
     setIsModalOpen(false);
    setSalesmanName("");
    setSalesmanPhone("");
    setEditSalesManID('')
    GetSalesmanData();
   }else{
    if(res1.result.status_code == 400 && res1.result.status?.includes('already exists')){
    toast.error(t("Salesman already exist with this number"));
    }else{
       toast.error(t(res1.result.status));
    }
  }

  } catch (error) {
    console.error(error);
  }
};


const handleDeleteSalesman = async(id)=>{

try {
    const payload = {
    company_id: store_id,
    salesman_id:id,
    is_delete:true
    };

    console.log("Payload", payload);

    // call your API here
   const res1 = await updateSalesman(payload);

    if(res1.result.status_code == 200){
    toast.success(t("Salesman deleted successfully"));
    GetSalesmanData();
   } 


  } catch (error) {
    console.error(error);
  }
}

  return (
    <>
      {loading && <LoadingSpinner />}
      {/* <div className="flex"> */}
      {/* <div className="flex flex-col bg-[#F6F7F9] min-h-[93vh]  flex-1"> */}
      <div className="w-full flex flex-col pb-2 overflow-y-auto  bg-[#F6F7F9]">
        <Navbar heading="All Salesmans" />
        <div className="overflow-y-auto custom-scrollbar">
          <div className="me-4 ms-3 font-extrabold">
            {/* <Breadcrumb
              separator={<DoubleRightOutlined />}
              items={[
                {
                  title: t("settings"),
                  key: "settings",
                  children: (
                    <Link to={routes.settings.userManagement}>
                      {t("settings")}
                    </Link>
                  ),
                },
                { title: t("user_management") },
              ]}
              className="relative mt-3"
            /> */}
            {retailerData?.status == "approved" ? (
                  <>
                    {/* <div className="bg-[#FFFFFF] shadow-sm rounded-xl grid mt-4 h-32">
                    <UserManagement />
                  </div> */}
                    <div className="flex flex-row items-end justify-between">
                      {/* {data?.length > 0 && (
                        <div className="font-semibold text-xl">
                          {t("allusers")}
                        </div>
                      )} */}
                      <SearchBox
                  // showBarcode={true}
                  searchResult={(values) => searchUser(values)}
                  placeholder={t("Search Salesman")}
                />

                      <div className="flex justify-between items-center">
                        <div className="font-semibold text-xl mt-2 ">
                          {/* {t("admin")} */}
                        </div>
                        <button
                          onClick={() => {
                            if (
                              checkPermission(
                                "/settings/salesman",
                                isGinne
                              )
                            ) {
                              setIsModalOpen(true);
                            }
                          }}
                          // onClick={() => {
                          //   if (!checkPermission("/settings/usermanagement", isGinne)) {
                          //     return;
                          //   }

                          //   const activeUsers = data.filter((u) => u.active).length;

                          //   const userLimit = data?.[0]?.no_of_user || 0;

                          //   if (activeUsers >= noOfUserLimit) {
                          //     toast.error(t("Cannot add a new user — the user limit for your store has been reached."));
                          //     return;
                          //   }

                          //   setShowComponent(true);
                          // }}
                          className={`font-semibold w-44 mt-5  h-10 border  rounded-lg bg-primaryBlue text-white text-base   flex justify-center items-center gap-2`}
                          type="submit"
                        >
                          <img src={plus} alt="plus" />
                          <p className="">{t("Add Salesman")}</p>
                        </button>
                      </div>
                    </div>
<div className="mt-3 ms-2">
   {salesmanData?.length > 0 ? (
                        <div className="font-semibold text-xl mt-2">
                          {t("All Salesmans")} <span>{`(${salesmanData?.length})`}</span>
                        </div>
                      ) : 
                      <div className="flex justify-center w-full mt-16 text-sm text-body text-center p-3 font-normal ">
                  {t("No salesman found.")}
                </div>}
</div>
                    <div className="grid grid-cols-3 gap-x-8 mb-4">
                      {/* {data.map((val, i) => ( */}
                      {salesmanData.map((val, i) => (
                          <div
                            key={i}
                            className="w-[345px] md:w-full h-30 shadow-sm hover:shadow-lg rounded-xl bg-[#FFFFFF] mt-4 p-3"
                          >

                          <div className="relative flex items-start justify-between">
  {/* Status Dot */}
  <div className="absolute top-0 start-1">
    <span
      className={`h-3 w-3 rounded-full block ${
        val?.is_delete === false ? "bg-green-500" : "bg-red-500"
      }`}
    />
  </div>

  {/* User Info */}
  <div className="ms-7">
    <div className="font-medium text-[#272728] text-lg">
      {val.name}
    </div>
     <div className="text-[#8A8A8A] text-base font-semibold tracking-wide">
      {`${t("Salesman ID:")} ${val.salesman_no}`}
    </div>
    <div className="text-[#8A8A8A] text-base font-semibold tracking-wide">
      {val.phone_no}
    </div>
  </div>

  {/* Menu */}
  {!val.is_deleted && (
    <Dropdown
      menu={{
        items: [
          {
            key: "1",
            icon: <EditOutlined />,
            label: t("edit"),
            onClick: () => {
              setSalesmanName(val.name);
              setSalesmanPhone(val.phone_no);
              setEditSalesManID(val.id);
              setIsEdit(true);
              setIsModalOpen(true);
            },
          },
          { type: "divider" },
          {
            key: "2",
            icon: <StopOutlined />,
            label: t("Delete"),
             onClick: () => {
                handleDeleteSalesman(val.id);
            },
          },
        ],
      }}
      trigger={["click"]}
      placement="bottomRight"
      arrow
    >
   <img
  src={menu}
  alt="menu"
  className="w-5 h-5 cursor-pointer "
/>
    </Dropdown>
  )}
</div>
                          </div>
                        ))}
                    </div>
                  </>
            ) : (
              <>
                <div className="flex justify-center w-full mt-16 text-sm text-body text-center p-3 font-normal ">
                  {retailerData?.status && retailerData?.status != "approved"
                    ? t(
                        "You cannot add or update salesman settings until your store is approved by myGINNE."
                      )
                    : ""}
                </div>
              </>
            )}
            {popup && (
              <Blockuserpopup
                onClose={() => setpopup(false)}
                data={blockdata}
                status={status}
              />
            )}
            {/* <p className='ms-20 mt-20'>Yet to be integrated</p> */}
          </div>
        </div>
        <Modal
  title={isEdit ? t("Update Salesman") : t("Add Salesman")}
  open={isModalOpen}
  onCancel={() => {
    setSalesmanName('');
    setSalesmanPhone('');
     setEditSalesManID(null)
     setIsEdit(false)
    setIsModalOpen(false)}}
  onOk={() => {
    if(isEdit){
  handleUpdateSalesman()
    }else{
  handleAddSalesman()
    }
  }}
  okText={t("Save")}
  cancelText={t('Cancel')}
  okButtonProps={{
    style: {
      backgroundColor: "#1b4597", // your primary color
      borderColor: "#1b4597",
      color: "#fff",
    },
  }}
>
 <div className="flex flex-col gap-5 mt-2 mb-2">
  {/* Name */}
  <div className="flex flex-col">
    <label className="text-sm font-medium text-gray-700 -mb-1">
      {t("Name")}
    </label>

    <InputBox
      name="first_name"
      placeholder={t("Enter Name")}
      value={salesmanName}
      maxLength={40}
      onChange={(e) => setSalesmanName(e.target.value)}
      className="h-11 rounded-lg border-gray-300 focus:border-primaryBlue focus:ring-1 focus:ring-primaryBlue"
    />
  </div>

  {/* Mobile Number */}
  <div className="flex flex-col mb-2">
    <label
      className={`text-sm font-medium text-gray-700 mb-1 ${
        i18n.language === "ar" ? "text-right" : ""
      }`}
    >
      {t("Mobile Number")}
    </label>

    <div className="flex items-center gap-2">
      {/* Flag */}
      <div className="h-11 min-w-[60px] flex items-center justify-center rounded-lg border border-gray-300 bg-gray-50">
        <img src={FlagIcon} alt="flag" className="h-5 w-7 object-contain" />
      </div>

      {/* Phone Input */}
      <Input
        type="tel"
        placeholder={t("01-xxxxxxxx")}
        value={salesmanPhone}
        onChange={(e) => {
          const value = e.target.value;
          if (value === "" || /^[0-9]*$/.test(value)) {
            setSalesmanPhone(value);
          }
        }}
        maxLength={getMaxLength(salesmanPhone)}
        className="h-11 flex-1 rounded-lg border-gray-300 focus:border-primaryBlue focus:ring-1 focus:ring-primaryBlue"
      />
    </div>
  </div>
</div>
</Modal>
      </div>
      {/* </div> */}
    </>
  );
};

export default AllSalesman;
